 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import TITLE_PAGE from '@/components/title_page'
 import LOVE_1 from '@/components/love_1'
 import TITLE from '@/components/Title'
 import COPYRIGHT from '@/components/Copyright'
 import PROLOGUE from '@/components/Prologue'
 import CHAPTER01 from '@/components/Chapter01'
 import CHAPTER02 from '@/components/Chapter02'
 import CHAPTER03 from '@/components/Chapter03'
 import CHAPTER04 from '@/components/Chapter04'
 import CHAPTER05 from '@/components/Chapter05'
 import CHAPTER06 from '@/components/Chapter06'
 import CHAPTER07 from '@/components/Chapter07'
 import CHAPTER08 from '@/components/Chapter08'
 import CHAPTER09 from '@/components/Chapter09'
 import CHAPTER10 from '@/components/Chapter10'
 import CHAPTER11 from '@/components/Chapter11'
 import CHAPTER12 from '@/components/Chapter12'
 import CHAPTER13 from '@/components/Chapter13'
 import CHAPTER14 from '@/components/Chapter14'
 import CHAPTER15 from '@/components/Chapter15'
 import CHAPTER16 from '@/components/Chapter16'
 import CHAPTER17 from '@/components/Chapter17'
 import CHAPTER18 from '@/components/Chapter18'
 import CHAPTER19 from '@/components/Chapter19'
 import CHAPTER20 from '@/components/Chapter20'
 import CHAPTER21 from '@/components/Chapter21'
 import CHAPTER22 from '@/components/Chapter22'
 import CHAPTER23 from '@/components/Chapter23'
 import CHAPTER24 from '@/components/Chapter24'
 import CHAPTER25 from '@/components/Chapter25'
 import CHAPTER26 from '@/components/Chapter26'
 import CHAPTER27 from '@/components/Chapter27'
 import CHAPTER28 from '@/components/Chapter28'
 import CHAPTER29 from '@/components/Chapter29'
 import CHAPTER30 from '@/components/Chapter30'
 import CHAPTER31 from '@/components/Chapter31'
 import CHAPTER32 from '@/components/Chapter32'
 import CHAPTER33 from '@/components/Chapter33'
 import CHAPTER34 from '@/components/Chapter34'
 import CHAPTER35 from '@/components/Chapter35'
 import CHAPTER36 from '@/components/Chapter36'
 import CHAPTER37 from '@/components/Chapter37'
 import CHAPTER38 from '@/components/Chapter38'
 import LOVE_2 from '@/components/love_2'
 import CHAP220022 from '@/components/chap220022'
 import CHAP220023 from '@/components/chap220023'
 import CREDITS from '@/components/credits'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/title_page",
 			"name" : "title_page",
 			"component" : TITLE_PAGE
 		},
 		{
 			"path" : "/love_1",
 			"name" : "love_1",
 			"component" : LOVE_1
 		},
 		{
 			"path" : "/Title",
 			"name" : "Title",
 			"component" : TITLE
 		},
 		{
 			"path" : "/Copyright",
 			"name" : "Copyright",
 			"component" : COPYRIGHT
 		},
 		{
 			"path" : "/Prologue",
 			"name" : "Prologue",
 			"component" : PROLOGUE
 		},
 		{
 			"path" : "/Chapter01",
 			"name" : "Chapter01",
 			"component" : CHAPTER01
 		},
 		{
 			"path" : "/Chapter02",
 			"name" : "Chapter02",
 			"component" : CHAPTER02
 		},
 		{
 			"path" : "/Chapter03",
 			"name" : "Chapter03",
 			"component" : CHAPTER03
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js